<div style="width: auto; overflow: auto">
    <app-common-list-table
            [request]="getRequest"
            [cols]="appName === 'avafitogest' ? colsAva : cols"
            [filtering]="filtering"
            [globalVisualTransform]="globalVisualTransform.bind(this)"
            [customExportCsv]="showTareasBioExportCsv"
            actionButtonText="Añadir Tarea"
            (actionButtonClick)="add()"
            (visualize)="show('info', $event)"
            (edit)="edit($event)"
            (duplicate)="duplicate($event)"
            (remove)="show('delete', $event)">

        <ng-template #header>
            <div *ngIf="rolUser === 'responsable' || appName === 'benibal'" style="margin-left: 20px;">
                <button
                    class="mx-2 btn"
                    type="button"
                    (click)="downloadCsv()"
                    style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white;">
                    <i class="fa fa-download"></i>
                    Exportar listado
                </button>
            </div>
        </ng-template>

        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                    [showDuplicate]="true"
                    (duplicateRowButtonEvent)="duplicate(data.data)"
                    (editRowButtonEvent)="edit(data.data)"
                    (deleteRowButtonEvent)="show('delete', data.data)"
                    (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>
